import { render, staticRenderFns } from "./gonggao.vue?vue&type=template&id=94312598&scoped=true&"
import script from "./gonggao.vue?vue&type=script&lang=js&"
export * from "./gonggao.vue?vue&type=script&lang=js&"
import style0 from "./gonggao.vue?vue&type=style&index=0&id=94312598&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94312598",
  null
  
)

export default component.exports